module.exports = __webpack_public_path__ + "static/media/Silencer.45a1e2e8.png";